import css from "../ServiceBookingModal/ServiceBookingModal.module.css";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import { ServiceBookingSchema } from "../../../validationSchemas/ServiceBookingSchema.js";
import { BsXLg, BsLayerBackward } from "react-icons/bs";
import { IoCar, IoPeople } from "react-icons/io5";
import SelectDate from "./SelectDate/SelectDate";
import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createRecord,
  getCarByLicensePlate,
  getPlannedVisits,
  // getRecordsForDay,
  getServiceDataForBooking,
} from "../../../redux/crm/operations.js";
import {
  selectCarDataByPlate,
  selectDates,
  selectIsCarByPlateLoading,
  selectIsServiceDataLoading,
  selectLoading,
  selectRecordById,
  // selectPeriodRecords,
  selectServiceData,
} from "../../../redux/crm/selectors.js";
import { selectSelectedServiceId } from "../../../redux/auth/selectors.js";
import SelectTime from "./SelectTime/SelectTime.jsx";
import { selectDate } from "../../../redux/cars/selectors.js";
import BtnsCloseAndSubmit from "../../sharedComponents/BtnsCloseAndSubmit/BtnsCloseAndSubmit.jsx";
import carList from "../../../utils/brands_models.json";
import CustomSelect from "../ServiceBookingModal/CustomSelect/CustomSelect.jsx";
import { showToast } from "../../../utils/showToast.js";
import LoaderSvg from "../../Loader/LoaderSvg.jsx";
import ServiceTypeSelect from "./ServiceTypeSelect/ServiceTypeSelect.jsx";
import clsx from "clsx";
import { getClientsList } from "../../../redux/client/operations.js";
import ChoseClientPopup from "./ChoseClientPopup/ChoseClientPopup.jsx";
import { selectClientsList } from "../../../redux/client/selectors.js";
import Modal from "../Modal/Modal.jsx";
import CreateServiceTypeModal from "./CreateServiceTypeModal/CreateServiceTypeModal.jsx";
import PhoneSelect from "../UserSettingsModal/UserSettingsProfile/PhoneSelect/PhoneSelect.jsx";
import ArchiveModal from "../../Archive/ArchiveModal/ArchiveModal.jsx";
import { useTour } from "@reactour/tour";
import {
  selectServicesPrices,
  selectTutorialPage,
} from "../../../redux/settings/selectors.js";
import {
  getAllCars,
  updateRecordData,
} from "../../../redux/cars/operations.js";
import { getServicesPrices } from "../../../redux/settings/operations.js";
import { format, parseISO } from "date-fns";
import {
  clearCarDataByPlate,
  clearRecordData,
} from "../../../redux/crm/slice.js";
import ChoseCarPopup from "./ChoseCarPopup/ChoseCarPopup.jsx";
import { useCan } from "../../../utils/permissions.js";
import { useLocation } from "react-router-dom";
import { selectChosenPeriod } from "../../../redux/accounting/selectors.js";
import { getClientsInWork } from "../../../redux/accounting/operations.js";

export default function ServiceBookingModal({
  onClose,
  postId,
  recordId,
  carSelectDate,
  car,
  initialHour,
}) {
  const dispatch = useDispatch();
  const can = useCan();
  const location = useLocation();
  const isInWorkPage = location.pathname === "/accounting/clients";

  const clientsInWorkPeriod = useSelector(selectChosenPeriod);
  console.log("clientsInWorkPeriod", clientsInWorkPeriod);

  const selectedDate = useSelector(selectDate);
  const dates = useSelector(selectDates);
  const loading = useSelector(selectLoading);
  const serviceDataLoading = useSelector(selectIsServiceDataLoading);
  const carDataByPlate = useSelector(selectCarDataByPlate);
  const isCarByPlateLoading = useSelector(selectIsCarByPlateLoading);
  const selectedServiceId = useSelector(selectSelectedServiceId);
  const { mechanics, posts } = useSelector(selectServiceData);
  const services = useSelector(selectServicesPrices);
  // const dayRecords = useSelector(selectDayRecords);
  const recordById = useSelector(selectRecordById);
  const part = useSelector(selectTutorialPage);
  // console.log("car in SBM", car);
  // console.log("recordId in SBM", recordId);
  // console.log("recordById", recordById);

  const [datesArray, setDatesArray] = useState([]);
  const [booking, setBooking] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownPostOpen, setIsDropdownPostOpen] = useState(false);
  const [isDropdownMechanicOpen, setIsDropdownMechanicOpen] = useState(false);
  const [openSelectIndex, setOpenSelectIndex] = useState(null);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openSearchCarModal, setOpenSearchCarModal] = useState(false);
  const [chosenClientName, setChosenClientName] = useState(null);
  const [chosenClientPhone, setChosenClientPhone] = useState(null);
  const [chosenClientCars, setChosenClientCars] = useState([]);
  const [chosenServicesTypes, setChosenServicesTypes] = useState([]);
  const [isCreateServiceTypeModalOpen, setIsCreateServiceTypeModalOpen] =
    useState(false);

  console.log("chosenClientCars", chosenClientCars);

  const [archiveModalOpen, setArchiveModalOpen] = useState(false);

  const { currentStep, setCurrentStep } = useTour();
  const selectRef = useRef(null);
  const choseClientButtonRef = useRef(null);
  const choseCarButtonRef = useRef(null);

  const [pickedDate, setPickedDate] = useState(() => {
    if (recordId || carSelectDate) {
      return new Date(selectedDate);
    }
    return new Date();
  });

  const [chosenTime, setChosenTime] = useState([]);
  const [initialChosenTime, setInitialChosenTime] = useState([]);

  const didInitEditMode = useRef(false);
  console.log("didInitEditMode", didInitEditMode.current);

  useEffect(() => {
    if (!recordId || !recordById?.booking?.length || didInitEditMode.current) {
      return;
    }

    const prepared = recordById.booking.map(item => ({
      appointment_date: parseISO(item.appointment_date),
      times: item.times,
    }));

    setChosenTime(prepared);
    setInitialChosenTime(prepared);

    didInitEditMode.current = true;
  }, [recordId, recordById]);

  const didInitPresetHour = useRef(false);

  useEffect(() => {
    if (recordId || initialHour == null || didInitPresetHour.current) {
      return;
    }

    const formattedHour = `${String(initialHour).padStart(2, "0")}:00`;
    const preset = [{ appointment_date: pickedDate, times: [formattedHour] }];

    setChosenTime(preset);
    setInitialChosenTime(preset);

    didInitPresetHour.current = true;
  }, [recordId, initialHour, pickedDate]);

  // console.log("services", services);
  // console.log("chosenClientName", chosenClientName);

  const makeOptions = carList.map(car => ({
    value: car.name,
    label: car.name,
  }));

  const handleToggleDropdown = index => {
    setOpenSelectIndex(openSelectIndex === index ? null : index);
  };

  const getModelOptions = make => {
    const selectedCar = carList?.find(
      car => car?.name?.toLocaleLowerCase() === make.toLocaleLowerCase()
    );
    if (selectedCar) {
      return selectedCar.models.map(model => ({
        value: model.name,
        label: model.name,
      }));
    }
    return [];
  };

  const getServicesOptions = chosenService => {
    const selectedService = services?.find(
      service => Number(service.id) === Number(chosenService)
    );
    if (selectedService) {
      return selectedService.children;
    }
    return [];
  };

  const getYearOptions = (make, model) => {
    if (!make || !model) {
      return;
    }
    const selectedCar = carList.find(
      car => car.name.toLocaleLowerCase() === make.toLocaleLowerCase()
    );
    const selectedCarModel = selectedCar?.models.find(
      car => model.toLocaleLowerCase() === car.name.toLocaleLowerCase()
    );
    if (selectedCarModel) {
      const yearArr = [];
      for (
        let i = selectedCarModel.start_year;
        i <= selectedCarModel.end_year;
        i++
      ) {
        yearArr.push(i);
      }
      return yearArr.map(year => ({
        value: year,
        label: year,
      }));
    }
    return [];
  };

  const [initialValues, setInitialValues] = useState({
    phone_number: "",
    phone_number_valid: undefined,
    car_number: "",
    vin: "",
    service_id: "",
    // prepayment: "",
    service_type: [],
    position: postId || posts[0]?.id,
    mechanic_id: "",
    name: "",
    make: "",
    model: "",
    year: "",
    note: "",
  });

  useEffect(() => {
    if (car) {
      setInitialValues({
        phone_number:
          car?.phone === "string"
            ? "Номер не вказано"
            : car?.phone
              ? car?.phone
              : "",
        phone_number_valid: undefined,
        car_number: car?.plate || "",
        vin: car?.vin || "",
        service_id: "",
        // prepayment: "",
        service_type: [],
        position: posts.length > 0 ? posts[0].id : "",
        mechanic_id: "",
        name: car?.client_name || "",
        make:
          typeof car?.vehicle?.make === "string"
            ? car.vehicle?.make.split(" ")[0]
            : "", // Додаємо дефолтне значення
        model: car?.vehicle?.model || "",
        year: car?.year || car?.vehicle?.year || "",
        note: "",
      });
      return;
    }
    if (!recordId) {
      return;
    }

    setChosenServicesTypes(recordById?.services_list || []);

    const customerName = `${recordById?.customer?.first_name || ""} ${
      recordById?.customer?.last_name || ""
    }`.trim();

    setInitialValues({
      phone_number: recordById?.customer?.phone || "",
      phone_number_valid: undefined,
      car_number: recordById?.vehicle?.plate || "",
      vin: recordById?.vehicle?.vin || "",
      service_id: Number(recordById?.service_id) || "",
      // prepayment: recordById?.prepayment || "",
      service_type: recordById?.services_list || [],
      position: recordById?.post_id || (posts.length > 0 ? posts[0].id : ""),
      mechanic_id: recordById?.mechanic_id || "",
      name: customerName || "",
      make: recordById?.vehicle?.make || "", // Додаємо дефолтне значення
      model: recordById?.vehicle?.model || "",
      year: recordById?.vehicle?.year || "",
      note: recordById?.comment || "",
    });
  }, [recordById, recordId, car]); // прибрав posts з залежностей, щоб не скидувати введені дані при перемикані дати

  useEffect(() => {
    if (chosenClientName === null && chosenClientPhone === null) return;

    setInitialValues(prev => {
      return {
        phone_number: chosenClientPhone || "",
        phone_number_valid: undefined,
        car_number: prev.car_number,
        vin: prev.vin,
        service_id: prev.service_id,
        // prepayment: prev.prepayment,
        position: prev.position,
        mechanic_id: prev.mechanic_id,
        name: chosenClientName || "",
        make: prev.make || "", // Додаємо дефолтне значення
        model: prev.model || "",
        year: prev.year || "",
        note: prev.note || "",
      };
    });
  }, [chosenClientName, chosenClientPhone]);

  const toggleDropdown = (status, changeStatus) => {
    changeStatus(!status);
  };

  const handlePostBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsDropdownPostOpen(false);
    }
  };
  const handleBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsDropdownOpen(false);
    }
  };

  const handleMechanicBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsDropdownMechanicOpen(false);
    }
  };

  useEffect(() => {
    const dateForApi = format(pickedDate, "yyyy-MM-dd");

    dispatch(getServiceDataForBooking(dateForApi));
    dispatch(getServicesPrices());
  }, [dispatch, pickedDate]);

  const clients = useSelector(selectClientsList);

  const handleOpenSearchModal = () => {
    if (clients.length === 0 || !clients) {
      dispatch(getClientsList())
        .unwrap()
        .then(() => {
          setOpenSearchModal(!openSearchModal);
        });
    } else {
      setOpenSearchModal(!openSearchModal);
    }
  };

  const handleOpenSearchCarModal = () => {
    setOpenSearchCarModal(!openSearchCarModal);
  };

  const openCreateServiceTypeModal = () =>
    setIsCreateServiceTypeModalOpen(true);
  const closeCreateServiceTypeModal = () =>
    setIsCreateServiceTypeModalOpen(false);

  const onArchiveSuccess = () => {
    // dispatch(getRecordsForDay(selectedDate)); // треба додати запит на отримання записів за період
    dispatch(getPlannedVisits(selectedDate));
    dispatch(
      getAllCars({
        view: "planner",
        to_date: dates.endDate,
        from_date: dates.startDate,
      })
    );
    dispatch(clearCarDataByPlate());
    dispatch(clearRecordData());
    onClose();
  };

  const bookedInfo =
    car?.status === "booked" && car?.service_date ? car.service_date : null;

  const handleSubmit = (values, actions) => {
    console.log("values", values);
    const totalSelectedHours = booking.reduce(
      (sum, day) => sum + (day.times?.length || 0),
      0
    );

    if (totalSelectedHours === 0) {
      showToast("Оберіть хоча б одну годину для запису", "error");
      actions.setSubmitting(false);
      return;
    }

    const restValues = { ...values };
    delete restValues.phone_number_valid;

    const recordData = {
      ...restValues,
      // shedule_date: datesArray[0]?.appointment_date,
      service_id: values.service_id ? Number(values.service_id) : null,
      // prepayment: values.prepayment ? Number(values.prepayment) : null,
      position: values.position ? Number(values.position) : null,
      mechanic_id: values.mechanic_id ? Number(values.mechanic_id) : null,
      dates: datesArray,
      hours_from: datesArray[0].start_time,
      recordId,
      booking,
    };
    console.log("recordData", recordData);

    recordId
      ? // && !car
        dispatch(updateRecordData(recordData))
          .unwrap()
          .then(() => {
            showToast("Запис успішно відредаговано", "success");
            // dispatch(getRecordsForDay(selectedDate)); //! треба додати запит на отримання записів за період
            dispatch(getPlannedVisits(selectedDate));
            dispatch(
              getAllCars({
                view: "planner",
                to_date: dates.endDate,
                from_date: dates.startDate,
              })
            );
          })
          .catch(() => {
            showToast(
              {
                title: "Щось пішло не так",
                description: "Будь ласка, спробуйте ще раз.",
              },
              "error"
            );
            // toast.error("Щось пішло не так. Спробуйте ще раз!");
          })
      : dispatch(createRecord(recordData))
          .unwrap()
          .then(() => {
            showToast("Запис успішно створено", "success");
            // toast.success("Запис успішно створено");
            isInWorkPage && dispatch(getClientsInWork(clientsInWorkPeriod));
            dispatch(getPlannedVisits(selectedDate));
            dispatch(
              getAllCars({
                view: "planner",
                to_date: dates.endDate,
                from_date: dates.startDate,
              })
            );
          })
          .catch(() => {
            showToast(
              {
                title: "Щось пішло не так",
                description: "Будь ласка, спробуйте ще раз.",
              },
              "error"
            );
            // toast.error("Щось пішло не так. Спробуйте ще раз!");
          });
    setDatesArray([]);
    setBooking([]);
    actions.resetForm();
    dispatch(clearCarDataByPlate());
    dispatch(clearRecordData());
    onClose();
  };

  const handleArchiveModalClose = () => {
    setArchiveModalOpen(false);
  };

  // ! Search by plate with debounce
  const searchTimeout = useRef(null);

  const handlePlateInputChange = value => {
    // Якщо рівно 8 символів → одразу запит без затримки
    if (value.length === 8) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
      dispatch(getCarByLicensePlate(value));
      return;
    }

    // Якщо більше 8 символів → debounce
    if (value.length > 8) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }

      searchTimeout.current = setTimeout(() => {
        dispatch(getCarByLicensePlate(value));
      }, 500); // debounce 500мс
    }
  };

  function AutofillVin({ carDataByPlate, isEditMode }) {
    const { setFieldValue, values } = useFormikContext();

    useEffect(() => {
      if (isEditMode) return;
      const car = Array.isArray(carDataByPlate)
        ? carDataByPlate[0]
        : carDataByPlate;
      if (!car) return;

      // ✅ Тільки це:
      if (car.vin && !values.vin) setFieldValue("vin", car.vin);
      if (car.plate_latin) setFieldValue("car_number", car.plate_latin);
      if (car.customer?.name && !values.name)
        setFieldValue("name", car.customer.name);
      if (car.customer?.phone && !values.phone_number)
        setFieldValue("phone_number", car.customer.phone);
    }, [carDataByPlate, isEditMode, setFieldValue, values.vin]);

    return null;
  }

  return loading ? (
    <LoaderSvg />
  ) : (
    <div className={css.serviceBookingModal} data-tour-createrecord="step-2">
      <BsXLg
        className={css.closeIcon}
        onClick={() => {
          dispatch(clearCarDataByPlate());
          dispatch(clearRecordData());
          onClose();
        }}
      />
      {recordId ? (
        <h3 className={css.header}>
          {bookedInfo ? (
            <span className={css.header}>
              Створення запису на {bookedInfo.date}
            </span>
          ) : (
            <>Редагування запису на {format(pickedDate, "dd.MM.yyyy")}</>
          )}
        </h3>
      ) : (
        <h3 className={css.header}>
          Створення запису на {format(pickedDate, "dd.MM.yyyy")}
        </h3>
      )}

      <p className={css.headerReminder}>* - Поля обов'язкові для заповнення</p>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={ServiceBookingSchema}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur
      >
        {({ values, touched, errors, setFieldValue }) => (
          <>
            <AutofillVin
              carDataByPlate={carDataByPlate}
              isEditMode={Boolean(recordId)}
            />
            <Form className={css.form}>
              <div className={css.rightSectionWrapper}>
                <div className={css.inputWrapper}>
                  <div
                    className={`${css.inputPhoneWrapper} ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                  >
                    <Field
                      className={clsx(
                        css.input,
                        (!values.phone_number || !values.name) && css.inputPhone
                      )}
                      type="text"
                      name="phone_number"
                      placeholder="Телефон *"
                      component={PhoneSelect}
                      recordModal={true}
                      disabled={recordId && car && values.phone_number}
                    />
                    {
                      <div className={css.popupBox} ref={choseClientButtonRef}>
                        <button
                          data-tour-createrecord="step-2.1"
                          className={css.findBtn}
                          onClick={handleOpenSearchModal}
                        >
                          <IoPeople className={css.peopleIcon} />
                        </button>
                        {openSearchModal && (
                          <ChoseClientPopup
                            onClose={() => setOpenSearchModal(false)}
                            isOpen={openSearchModal}
                            buttonRef={choseClientButtonRef}
                            setChosenClientName={setChosenClientName}
                            setChosenClientPhone={setChosenClientPhone}
                            setChosenClientCars={setChosenClientCars}
                            clients={clients}
                          />
                        )}
                      </div>
                    }
                  </div>

                  <ErrorMessage
                    name="phone_number"
                    component="div"
                    className={css.errorMsg}
                  />
                  {!errors.phone_number &&
                    !values.phone_number &&
                    !recordId &&
                    car && (
                      <p className={css.reminder}>
                        Телефон повинен відповідати формату 380123456789
                      </p>
                    )}
                  {recordId && !car && (
                    <p className={css.reminder}>
                      Для редагування номеру зверніться в тех підтримку
                    </p>
                  )}
                </div>
                <div
                  className={`${css.inputWrapper}  ${
                    currentStep === 3 &&
                    part === "create-record" &&
                    css.tourBorder
                  }`}
                >
                  <div
                    className={`${css.inputPhoneWrapper} ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                  >
                    <Field name="car_number">
                      {({ field }) => (
                        <input
                          {...field}
                          className={clsx(
                            css.input,
                            css.plateInput,
                            chosenClientCars &&
                              chosenClientCars.length > 0 &&
                              css.carPlateInput
                          )}
                          type="text"
                          placeholder="AX2945OP * (eng)"
                          onChange={e => {
                            const upperValue = e.target.value.toUpperCase();

                            field.onChange({
                              target: {
                                name: field.name,
                                value: upperValue,
                              },
                            }); // оновлює Formik state
                            handlePlateInputChange(e.target.value); // твоя логіка
                          }}
                        />
                      )}
                    </Field>
                    {chosenClientCars && chosenClientCars.length > 0 && (
                      <div className={css.popupCarBox} ref={choseCarButtonRef}>
                        <button
                          data-tour-createrecord="step-2.1"
                          className={css.findBtn}
                          onClick={handleOpenSearchCarModal}
                        >
                          <IoCar className={css.peopleIcon} />
                        </button>
                        {openSearchCarModal && (
                          <ChoseCarPopup
                            onClose={() => setOpenSearchCarModal(false)}
                            isOpen={openSearchCarModal}
                            buttonRef={choseCarButtonRef}
                            cars={chosenClientCars}
                            setFieldValue={setFieldValue}
                          />
                        )}
                      </div>
                    )}
                  </div>

                  <ErrorMessage
                    name="car_number"
                    component="div"
                    className={css.errorMsg}
                  />
                </div>
                <div className={css.inputWrapper}>
                  <Field
                    className={css.input}
                    type="text"
                    name="vin"
                    placeholder="VIN"
                  />
                  <ErrorMessage
                    name="vin"
                    component="div"
                    className={css.errorMsg}
                  />
                </div>
                <div className={css.wrapper}>
                  <div
                    className={`${css.inputWrapper}  ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                    ref={selectRef}
                    onBlur={handleBlur}
                  >
                    <Field
                      name="service_id"
                      component={CustomSelect}
                      placeholderName="Послуга *"
                      options={services?.map(service => ({
                        value: service.id,
                        label: service.name,
                      }))}
                      setFieldValue={setFieldValue}
                      // isDisabled={!values.make}
                      isOpen={openSelectIndex === 4}
                      toggleDropdown={() => handleToggleDropdown(4)}
                    />
                    <ErrorMessage
                      name="service_id"
                      component="div"
                      className={css.errorMsg}
                    />
                  </div>
                  <div
                    className={`${css.inputWrapper}  ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                  >
                    <Field
                      name="service_type"
                      component={ServiceTypeSelect}
                      placeholderName="Вид послуги *"
                      data={getServicesOptions(values.service_id)}
                      serviceId={values.service_id}
                      chosenServices={chosenServicesTypes}
                      setFieldValue={setFieldValue}
                      // isDisabled={!values.make}
                      isOpen={openSelectIndex === 7}
                      toggleDropdown={() => handleToggleDropdown(7)}
                      openCreateServiceTypeModal={openCreateServiceTypeModal}
                    />
                    <ErrorMessage
                      name="service_type"
                      component="div"
                      className={css.errorMsg}
                    />
                  </div>
                </div>
                <div className={css.bottomRightSectionWrapper}>
                  <div
                    className={`${css.inputWrapper}  ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                    ref={selectRef}
                    onBlur={handlePostBlur}
                  >
                    <Field
                      name="position"
                      component={CustomSelect}
                      placeholderName="ПОСТ *"
                      options={posts?.map(post => ({
                        value: post.id,
                        label: post.name,
                      }))}
                      setFieldValue={setFieldValue}
                      isOpen={openSelectIndex === 5}
                      toggleDropdown={() => handleToggleDropdown(5)}
                    />
                    <ErrorMessage
                      name="position"
                      component="div"
                      className={css.errorMsg}
                    />
                  </div>
                  <div
                    className={`${css.inputWrapper}  ${
                      currentStep === 3 &&
                      part === "create-record" &&
                      css.tourBorder
                    }`}
                    ref={selectRef}
                    onBlur={handleMechanicBlur}
                  >
                    <Field
                      name="mechanic_id"
                      component={CustomSelect}
                      placeholderName="Оберіть механіка *"
                      options={mechanics?.map(mechanic => ({
                        value: mechanic.id,
                        label: mechanic.full_name,
                      }))}
                      setFieldValue={setFieldValue}
                      // isDisabled={!values.make}
                      isOpen={openSelectIndex === 6}
                      toggleDropdown={() => handleToggleDropdown(6)}
                    />
                    <ErrorMessage
                      name="mechanic_id"
                      component="div"
                      className={css.errorMsg}
                    />
                  </div>
                </div>
                {recordId && can("archive", "create") && (
                  <div className={css.btnSaveWrapper}>
                    <button
                      className={css.btnArchive}
                      onClick={e => {
                        e.preventDefault();
                        setArchiveModalOpen(true);
                      }}
                    >
                      <BsLayerBackward size={16} />
                    </button>
                    <p>Архівувати авто</p>
                  </div>
                )}
              </div>
              <div className={css.leftSectionWrapper}>
                <div
                  className={`${css.inputWrapper}  ${
                    currentStep === 3 &&
                    part === "create-record" &&
                    css.tourBorder
                  }`}
                >
                  <Field
                    className={css.input}
                    type="text"
                    name="name"
                    placeholder="ПІБ *"
                    disabled={
                      (recordId && car?.client_name) ||
                      car?.customer?.first_name
                    }
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className={css.errorMsg}
                  />
                </div>
                <div
                  className={`${css.inputWrapper}  ${
                    currentStep === 3 &&
                    part === "create-record" &&
                    css.tourBorder
                  }`}
                >
                  <Field
                    name="make"
                    component={CustomSelect}
                    placeholderName="Марка автомобіля *"
                    options={makeOptions}
                    setFieldValue={setFieldValue}
                    isOpen={openSelectIndex === 0}
                    toggleDropdown={() => handleToggleDropdown(0)}
                    carDataByPlate={carDataByPlate}
                    recordId={recordId}
                  />
                  <ErrorMessage
                    name="make"
                    component="div"
                    className={css.errorMsg}
                  />
                </div>

                <div
                  className={`${css.inputWrapper}  ${
                    currentStep === 3 &&
                    part === "create-record" &&
                    css.tourBorder
                  }`}
                >
                  <Field
                    name="model"
                    component={CustomSelect}
                    placeholderName="Модель автомобіля *"
                    options={getModelOptions(values.make)}
                    setFieldValue={setFieldValue}
                    isDisabled={!values.make}
                    isOpen={openSelectIndex === 1}
                    toggleDropdown={() => handleToggleDropdown(1)}
                    carDataByPlate={carDataByPlate}
                    recordId={recordId}
                  />
                  <ErrorMessage
                    name="model"
                    component="div"
                    className={css.errorMsg}
                  />
                  {!values.make && !touched.model && (
                    <p className={css.reminder}>
                      Спочатку оберіть марку автомобіля
                    </p>
                  )}
                </div>
                <div className={css.wrapper}>
                  <div className={css.inputWrapper}>
                    <Field
                      name="year"
                      component={CustomSelect}
                      placeholderName="Рік випуску"
                      options={getYearOptions(values.make, values.model)}
                      setFieldValue={setFieldValue}
                      isDisabled={!values.make && !values.model}
                      isOpen={openSelectIndex === 2}
                      toggleDropdown={() => handleToggleDropdown(2)}
                      carDataByPlate={carDataByPlate}
                      recordId={recordId}
                    />
                    <ErrorMessage
                      name="year"
                      component="div"
                      className={css.errorMsg}
                    />
                    {!values.model && !touched.year && (
                      <p className={css.reminder}>
                        Спочатку оберіть марку та модель автомобіля
                      </p>
                    )}
                  </div>
                  <Field
                    // as="textarea"
                    name="note"
                    className={css.input}
                    placeholder="Проблема"
                  />
                </div>
                <div
                  className={`${css.calendar}  ${
                    currentStep === 3 &&
                    part === "create-record" &&
                    css.tourBorder
                  }`}
                >
                  <SelectDate
                    // setNewDate={setNewDate}
                    recordId={recordId}
                    carSelectDate={carSelectDate}
                    value={pickedDate}
                    onChange={setPickedDate}
                  />
                  {serviceDataLoading ? (
                    <LoaderSvg />
                  ) : (
                    <div className={css.timeWrapper}>
                      <SelectTime
                        postId={values.position || posts[0]?.id}
                        setDatesArray={setDatesArray}
                        setChosenTime={setChosenTime}
                        setInitialChosenTime={setInitialChosenTime}
                        chosenTime={chosenTime}
                        initialChosenTime={initialChosenTime}
                        pickedDate={pickedDate}
                        recordId={recordId}
                        setBooking={setBooking}
                        car={car}
                        mechanicId={values.mechanic_id}
                      />
                    </div>
                  )}
                  {/* Інформація про обрану дату клієнтом */}
                  {bookedInfo && (
                    <div className={css.bookedInfoUnderCalendar}>
                      Дата обрана клієнтом: {bookedInfo.date} о{" "}
                      {bookedInfo.time}
                    </div>
                  )}
                </div>
                <div className={css.btnWrapper}>
                  <BtnsCloseAndSubmit
                    onClose={() => {
                      (dispatch(clearCarDataByPlate()),
                        dispatch(clearRecordData()),
                        onClose(),
                        setCurrentStep(currentStep + 1));
                    }}
                    handleSubmit={handleSubmit}
                    btnSave={"Зберегти"}
                    btnClose={"Закрити"}
                  />
                </div>
              </div>

              {isCreateServiceTypeModalOpen && (
                <Modal
                  isOpen={isCreateServiceTypeModalOpen}
                  onClose={closeCreateServiceTypeModal}
                >
                  <CreateServiceTypeModal
                    onClose={closeCreateServiceTypeModal}
                    serviceParentId={values.service_id}
                    setChosenServicesTypes={setChosenServicesTypes}
                  />
                </Modal>
              )}
            </Form>
          </>
        )}
      </Formik>
      {archiveModalOpen && (
        <Modal isOpen={archiveModalOpen} onClose={handleArchiveModalClose}>
          <ArchiveModal
            onClose={handleArchiveModalClose}
            carId={recordId}
            plate={car?.plate || ""}
            onSuccess={onArchiveSuccess}
          />
        </Modal>
      )}
    </div>
  );
}
